import React from 'react';
import Tab from '@mui/material/Tab';
import {Link} from 'react-router-dom';

interface StakeTabProps {
    label?: string;
    to: string;
    value: string;
    selected?: boolean;
}

function EarnTab(props: StakeTabProps) {

    return <Tab component={Link} {...props} disableRipple />
}

export default EarnTab;